import { render, staticRenderFns } from "./SplitInput.vue?vue&type=template&id=4e90bd66&scoped=true"
import script from "./SplitInput.vue?vue&type=script&lang=js"
export * from "./SplitInput.vue?vue&type=script&lang=js"
import style0 from "./SplitInput.vue?vue&type=style&index=0&id=4e90bd66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e90bd66",
  null
  
)

export default component.exports